import React, { ReactElement } from 'react';
import WizardMultistep from './components/Steps/WizardMultistep';
import WizardStepComponent from './components/Steps/WizardStep';
import { WizardName, WizardStep } from '../types';
import { ApiDataProvider, DataCollectionProvider, WizardMultistepProvider } from '../hooks';

// === STEPS ===
// STEP 1
import StepBuildingBasicInfo from './otz-wizard/steps/step1/StepBuildingBasicInfo';
// STEP 2
import StepYearOfBuilding from './otz-wizard/steps/step2/StepYearOfBuilding';
import StepHavePENB from './otz-wizard/steps/step2/subSteps/StepHavePENB';
import StepTypeOfPENB from './otz-wizard/steps/step2/subSteps/StepTypeOfPENB';
import StepAvgHeatTransferOfBuildingPENB from './otz-wizard/steps/step2/subSteps/StepAvgHeatTransferOfBuildingPENB';
import StepMeasuredHeatLossPENB from './otz-wizard/steps/step2/subSteps/StepMeasuredHeatLossPENB';
import StepBuildingVolumeVPENB from './otz-wizard/steps/step2/subSteps/StepBuildingVolumeVPENB';
import StepTotalAreaOfEvaluatedBuildingCoverPENB from './otz-wizard/steps/step2/subSteps/StepTotalAreaOfEvaluatedBuildingCoverPENB';
import StepEnergyLossPENB from './otz-wizard/steps/step2/subSteps/StepEnergyLossPENB';
// STEP 3
import StepHouseFloorPlaneShape from './otz-wizard/steps/step3/StepHouseFloorPlaneShape';
// STEP 4
// STEP 5
import StepRoofType from './otz-wizard/steps/step5/StepRoofType';
// STEP 6
import StepHouseFloorCount from './otz-wizard/steps/step6/StepHouseFloorCount';
// STEP 7
import StepGarageBasementAtticArea from './otz-wizard/steps/step7/StepGarageBasementAtticArea';
// STEP 8
import StepRoomDispositions from './otz-wizard/steps/step8/StepRoomDispositions';
// STEP 9
import StepBathroomCount from './otz-wizard/steps/step9/StepBathroomCount';
// STEP 10
// STEP 11
import StepHouseGlazing from './otz-wizard/steps/step11/StepHouseGlazing';
// STEP 12
import StepWallInsulation from './otz-wizard/steps/step12/StepWallInsulation';
import StepWallInsulationThickness from './otz-wizard/steps/step12/substeps/StepWallInsulationThickness';
// STEP 13
import StepFloorInsulation from './otz-wizard/steps/step13/StepFloorInsulation';
import StepFloorInsulationThickness from './otz-wizard/steps/step13/substeps/StepFloorInsulationThickness';
// STEP 14
import StepRoofInsulation from './otz-wizard/steps/step14/StepRoofInsulation';
import StepRoofInsulationThickness from './otz-wizard/steps/step14/substeps/StepRoofInsulationThickness';
// FINAL STEP
import StepFinal from './otz-wizard/steps/final/StepFinal';
import StepHouseFloorPlaneShapeDetail from './otz-wizard/steps/step3/substeps/StepHouseFloorPlaneShapeDetail';
import BottomBar from './components/Layout/BottomBar';
import StepAtticHeatedBool from './otz-wizard/steps/step7/substeps/StepAtticHeatedBool';
import StepRecuperationBool from './otz-wizard/steps/step10/StepRecuperationBool';

function OTZWizardApp(): ReactElement<'div'> | null {
    //const isLoggedInWithSocialProvider = !!window.defaults.facebookId || !!window.defaults.googleId;
    return (
        <ApiDataProvider>
            <WizardMultistepProvider
            // Keep this value in all cases, this sets login as first step in wizard
            // initialStepId={WizardStep.BuildingBasicInfo}
            >
                <DataCollectionProvider wizardName={WizardName.otz}>
                    <section className="wiz-section">
                        <div className="container">
                            <div className="row">
                                <div className="col">
                                    <WizardMultistep
                                        // This sets initial step that will appear to user
                                        initialStepId={
                                            window.wizardDefaults
                                                ? WizardStep.YearOfBuilding
                                                : WizardStep.BuildingBasicInfo
                                        }
                                    >
                                        <WizardStepComponent
                                            id={WizardStep.BuildingBasicInfo}
                                            nextStepId={WizardStep.YearOfBuilding}
                                            phaseIndex={2}
                                        >
                                            <StepBuildingBasicInfo />
                                        </WizardStepComponent>

                                        <WizardStepComponent
                                            id={WizardStep.YearOfBuilding}
                                            nextStepId={WizardStep.HavePENB}
                                            phaseIndex={2}
                                        >
                                            <StepYearOfBuilding />
                                        </WizardStepComponent>

                                        <WizardStepComponent
                                            id={WizardStep.HavePENB}
                                            nextStepId={WizardStep.TypeOfPENB}
                                            phaseIndex={2}
                                        >
                                            <StepHavePENB />
                                        </WizardStepComponent>

                                        {/* Rozcestník */}
                                        <WizardStepComponent
                                            id={WizardStep.TypeOfPENB}
                                            nextStepId={WizardStep.MeasuredHeatLossPENB}
                                            phaseIndex={2}
                                        >
                                            <StepTypeOfPENB />
                                        </WizardStepComponent>

                                        {/* PENB DO 1.9.2020 */}
                                        <WizardStepComponent
                                            id={WizardStep.MeasuredHeatLossPENB}
                                            nextStepId={WizardStep.BuildingVolumeVPENB}
                                            phaseIndex={2}
                                        >
                                            <StepMeasuredHeatLossPENB />
                                        </WizardStepComponent>

                                        <WizardStepComponent
                                            id={WizardStep.BuildingVolumeVPENB}
                                            nextStepId={WizardStep.Final}
                                            phaseIndex={2}
                                        >
                                            <StepBuildingVolumeVPENB />
                                        </WizardStepComponent>

                                        {/* PENB OD 1.9.2020 */}
                                        <WizardStepComponent
                                            id={WizardStep.AvgHeatTransferOfBuildingPENB}
                                            nextStepId={WizardStep.TotalAreaOfEvaluatedBuildingCoverPENB}
                                            phaseIndex={2}
                                        >
                                            <StepAvgHeatTransferOfBuildingPENB />
                                        </WizardStepComponent>

                                        <WizardStepComponent
                                            id={WizardStep.TotalAreaOfEvaluatedBuildingCoverPENB}
                                            nextStepId={WizardStep.EnergyLossPENB}
                                            phaseIndex={2}
                                        >
                                            <StepTotalAreaOfEvaluatedBuildingCoverPENB />
                                        </WizardStepComponent>

                                        <WizardStepComponent
                                            id={WizardStep.EnergyLossPENB}
                                            nextStepId={WizardStep.Final}
                                            phaseIndex={2}
                                        >
                                            <StepEnergyLossPENB />
                                        </WizardStepComponent>

                                        {/* STEP 3 */}
                                        <WizardStepComponent
                                            id={WizardStep.HouseFloorPlanShape}
                                            nextStepId={WizardStep.HouseFloorPlanShapeDetail}
                                            phaseIndex={2}
                                        >
                                            <StepHouseFloorPlaneShape />
                                        </WizardStepComponent>

                                        <WizardStepComponent
                                            id={WizardStep.HouseFloorPlanShapeDetail}
                                            nextStepId={WizardStep.RoofType}
                                            phaseIndex={2}
                                        >
                                            <StepHouseFloorPlaneShapeDetail />
                                        </WizardStepComponent>

                                        {/*STEP 4 */}

                                        {/* STEP 5 */}
                                        <WizardStepComponent
                                            id={WizardStep.RoofType}
                                            nextStepId={WizardStep.FloorCount}
                                            phaseIndex={2}
                                        >
                                            <StepRoofType />
                                        </WizardStepComponent>

                                        {/* STEP 6 */}
                                        <WizardStepComponent
                                            id={WizardStep.FloorCount}
                                            nextStepId={WizardStep.GarageBasementAtticArea}
                                            phaseIndex={3}
                                        >
                                            <StepHouseFloorCount />
                                        </WizardStepComponent>

                                        {/* STEP 7 */}
                                        <WizardStepComponent
                                            id={WizardStep.GarageBasementAtticArea}
                                            nextStepId={WizardStep.AtticHeated}
                                            phaseIndex={2}
                                        >
                                            <StepGarageBasementAtticArea />
                                        </WizardStepComponent>

                                        {/* STEP 7 - mezikrok - vytápěná půda */}
                                        <WizardStepComponent
                                            id={WizardStep.AtticHeated}
                                            nextStepId={WizardStep.RoomDispositions}
                                            phaseIndex={2}
                                        >
                                            <StepAtticHeatedBool />
                                        </WizardStepComponent>

                                        {/* STEP 8 */}
                                        <WizardStepComponent
                                            id={WizardStep.RoomDispositions}
                                            nextStepId={WizardStep.NumberOfBathrooms}
                                            phaseIndex={2}
                                        >
                                            <StepRoomDispositions />
                                        </WizardStepComponent>

                                        {/* STEP 9 */}
                                        <WizardStepComponent
                                            id={WizardStep.NumberOfBathrooms}
                                            nextStepId={WizardStep.Recuperation}
                                            phaseIndex={2}
                                        >
                                            <StepBathroomCount />
                                        </WizardStepComponent>

                                        {/* STEP 10 */}
                                        <WizardStepComponent
                                            id={WizardStep.Recuperation}
                                            nextStepId={WizardStep.HouseGlazing}
                                            phaseIndex={2}
                                        >
                                            <StepRecuperationBool />
                                        </WizardStepComponent>

                                        {/* STEP 11 */}
                                        <WizardStepComponent
                                            id={WizardStep.HouseGlazing}
                                            nextStepId={WizardStep.WallInsulation}
                                            phaseIndex={2}
                                        >
                                            <StepHouseGlazing />
                                        </WizardStepComponent>

                                        {/* STEP 12 */}
                                        <WizardStepComponent
                                            id={WizardStep.WallInsulation}
                                            nextStepId={WizardStep.WallInsulationThickness}
                                            phaseIndex={2}
                                        >
                                            <StepWallInsulation />
                                        </WizardStepComponent>

                                        <WizardStepComponent
                                            id={WizardStep.WallInsulationThickness}
                                            nextStepId={WizardStep.FloorInsulation}
                                            phaseIndex={2}
                                        >
                                            <StepWallInsulationThickness />
                                        </WizardStepComponent>

                                        {/* STEP 13 */}
                                        <WizardStepComponent
                                            id={WizardStep.FloorInsulation}
                                            nextStepId={WizardStep.FloorInsulationThickness}
                                            phaseIndex={2}
                                        >
                                            <StepFloorInsulation />
                                        </WizardStepComponent>

                                        <WizardStepComponent
                                            id={WizardStep.FloorInsulationThickness}
                                            nextStepId={WizardStep.RoofInsulation}
                                            phaseIndex={2}
                                        >
                                            <StepFloorInsulationThickness />
                                        </WizardStepComponent>

                                        {/* STEP 14 */}
                                        <WizardStepComponent
                                            id={WizardStep.RoofInsulation}
                                            nextStepId={WizardStep.RoofInsulationThickness}
                                            phaseIndex={2}
                                        >
                                            <StepRoofInsulation />
                                        </WizardStepComponent>

                                        <WizardStepComponent
                                            id={WizardStep.RoofInsulationThickness}
                                            nextStepId={WizardStep.Final}
                                            phaseIndex={2}
                                        >
                                            <StepRoofInsulationThickness />
                                        </WizardStepComponent>

                                        {/* FINAL STEP */}
                                        <WizardStepComponent id={WizardStep.Final} phaseIndex={3}>
                                            <StepFinal />
                                        </WizardStepComponent>
                                    </WizardMultistep>
                                </div>
                            </div>
                        </div>
                    </section>
                    <BottomBar />
                </DataCollectionProvider>
            </WizardMultistepProvider>
        </ApiDataProvider>
    );
}

export default OTZWizardApp;
